<template>
  <div class="imagecropsection">
    <p>{{resource.imagecropperhead}}</p>
    <el-row type="flex" align="middle" justify="center">
      <el-col :span="20">
        <vue-cropper
          ref="cropper"
          alt="Source Image"
          :view-mode="1"
          :min-container-width="250"
          :min-container-height="180"
          :container-style="{'height': '340px'}"
          :src="this.imgSrc"
          :crop="onCrop"
          >
        </vue-cropper>
      </el-col>
    </el-row>
    <p>{{resource.imagecroppersubhead}} <span>{{cropImageWidth}}</span> x <span>{{cropImageHeight}}</span>px</p>


    <!-- :aspectRatio="1"
    :cropBoxResizable="false"
    :minCropBoxWidth="1024"
    :minCropBoxHeight="1024"
    :maxCropBoxWidth="1024"
    :maxCropBoxHeight="1024" -->


<!--     <el-row type="flex" align="middle" justify="center">
      <el-col :span="24" style="text-align: center;">
        <span>Ausgewählte Bildgröße:</span>
        <span>
          <span>{{cropImageHeight}}px</span>
          <span>x</span>
          <span>{{cropImageWidth}}px</span>
        </span>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import VueCropper from 'vue-cropperjs'

export default {
  props: {
    imgSrc: {
      type: String
    },
    extension: {
      type: String
    }
  },
  data () {
    return {
      cropImg: '',
      cropImageHeight: 0,
      cropImageWidth: 0
    }
  },
  computed: {
    ...mapGetters([
      'resource'
    ])
  },
  // created () {
  //   this.eventBus.$on('saveImage', this.handleSaveImageClick)
  // },
  // beforeDestroy () {
  //   this.eventBus.$off('saveImage', this.handleSaveImageClick)
  // },
  // mounted () {
  //   if (typeof (Event) === 'function') {
  //     // modern browsers
  //     window.dispatchEvent(new Event('resize'))
  //   } else {
  //     // for IE and other old browsers
  //     // causes deprecation warning on modern browsers
  //     var event = window.document.createEvent('UIEvents')
  //     event.initUIEvent('resize', true, false, window, 0)
  //     window.dispatchEvent(event)
  //   }
  // },
  mounted () {
  },
  methods: {
    getResult () {
      const result = this.$refs.cropper.getCroppedCanvas()
      let image = result.toDataURL(`image/${this.extension}`)
      image = image.replace(/^data:image\/(png|jpg|jpeg);base64,/, '')
      return {
        image,
        width: this.cropImageWidth,
        height: this.cropImageHeight,
        extension: this.extension
      }
    },
    onCrop (event) {
      const detail = event.detail
      // detail.height = 1024
      // detail.width = 1024
      this.cropImageHeight = Math.round(detail.height)
      this.cropImageWidth = Math.round(detail.width)
    }
    // drawCropWindow () {
    //   let data = {
    //     left: 100,
    //     top: 100,
    //     width: 100,
    //     height: 100
    //   }
    //   this.$refs.cropper.setCropBoxData(data)
    // }
  },
  components: {
    VueCropper
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Shared/Cropper.vue